// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acKFgFzAd8EuTm8aiOwV{justify-content:space-between;align-items:center;height:32px;margin-top:4px;display:flex}.RXTm4ajRQScNsn_ybKvP{grid-template-columns:1fr 1fr 1fr;justify-content:space-between;align-items:center;height:32px;margin-bottom:4px;display:grid}.RXTm4ajRQScNsn_ybKvP .SLz9lfZotMow4Qgx1O5I{justify-content:flex-start}.RXTm4ajRQScNsn_ybKvP .zXfnnT4l98AANvzMnSlw{justify-content:center}.RXTm4ajRQScNsn_ybKvP .ULjJtaNTksgpjoqiesr2{justify-content:flex-end}.CNn2fCWZAPkP3kr3gbZH{align-items:center;display:flex}.AXqeYPvyn24QvpA1cBWJ{background:var(--border-neutral-default);width:100%;height:1px;margin-top:4px;margin-bottom:4px}.iuRnWhqZlnYPntDaLwwI{display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `acKFgFzAd8EuTm8aiOwV`,
	"footer": `RXTm4ajRQScNsn_ybKvP`,
	"left": `SLz9lfZotMow4Qgx1O5I`,
	"center": `zXfnnT4l98AANvzMnSlw`,
	"right": `ULjJtaNTksgpjoqiesr2`,
	"flex": `CNn2fCWZAPkP3kr3gbZH`,
	"divider": `AXqeYPvyn24QvpA1cBWJ`,
	"middleContent": `iuRnWhqZlnYPntDaLwwI`
};
export default ___CSS_LOADER_EXPORT___;
